import React, { Component } from 'react';

import { LIBERATION_TYPE } from 'modules/content/constants';
import PropTypes from 'prop-types';

import DurationDays from './DurationDays';
import LiberationByDate from './LiberationByDate';
import LiberationByDay from './LiberationByDay';

import './Dripping.scss';

export default class Dripping extends Component {
  static propTypes = {
    type: PropTypes.string,
    hasDuration: PropTypes.bool,
    durationDays: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    liberationDate: PropTypes.number,
    liberationDays: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    liberationType: PropTypes.string,
    changeLiberationType: PropTypes.func,
    changeLiberationDays: PropTypes.func,
    changeHasDuration: PropTypes.func,
    changeLiberationDate: PropTypes.func,
    changeDurationDays: PropTypes.func,
    errors: PropTypes.shape({
      liberationDate: PropTypes.arrayOf(PropTypes.string),
      liberationDays: PropTypes.arrayOf(PropTypes.string),
      durationDays: PropTypes.arrayOf(PropTypes.string)
    })
  };

  setDrippingType = (type) => {
    const liberationType = this.props.liberationType !== type ? type : null;

    this.props.changeLiberationType(liberationType);
  };

  changeHasDuration = (e) => {
    this.props.changeHasDuration(e.target.checked);
  };

  changeDurationDays = (e) => {
    this.props.changeDurationDays(e.target.value);
  };

  render() {
    const {
      hasDuration,
      liberationType,
      changeLiberationDays,
      changeLiberationDate,
      durationDays,
      liberationDays,
      liberationDate,
      errors
    } = this.props;

    return (
      <div className="input__group">
        <div className="dripping">
          <LiberationByDay
            active={liberationType === LIBERATION_TYPE.BY_DAYS}
            setActive={() => this.setDrippingType(LIBERATION_TYPE.BY_DAYS)}
            value={liberationDays}
            onChange={changeLiberationDays}
            errors={errors?.liberationDays || []}
          />
          <LiberationByDate
            active={liberationType === LIBERATION_TYPE.BY_DATE}
            setActive={() => this.setDrippingType(LIBERATION_TYPE.BY_DATE)}
            value={liberationDate}
            onChange={changeLiberationDate}
            errors={errors?.liberationDate || []}
          />
        </div>
        <DurationDays
          active={hasDuration}
          setActive={this.changeHasDuration}
          value={durationDays}
          onChange={this.changeDurationDays}
          errors={errors?.durationDays || []}
        />
      </div>
    );
  }
}
